var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.33335H1.66699M9.16699 11.6667H5.00033M1.66699 6.83335L1.66699 13.1667C1.66699 14.1001 1.66699 14.5668 1.84865 14.9233C2.00844 15.2369 2.2634 15.4919 2.57701 15.6517C2.93353 15.8334 3.40024 15.8334 4.33366 15.8334L15.667 15.8334C16.6004 15.8334 17.0671 15.8334 17.4236 15.6517C17.7372 15.4919 17.9922 15.2369 18.152 14.9233C18.3337 14.5668 18.3337 14.1001 18.3337 13.1667V6.83335C18.3337 5.89993 18.3337 5.43322 18.152 5.0767C17.9922 4.7631 17.7372 4.50813 17.4236 4.34834C17.0671 4.16669 16.6004 4.16669 15.667 4.16669L4.33366 4.16669C3.40024 4.16669 2.93353 4.16669 2.57701 4.34834C2.2634 4.50813 2.00844 4.7631 1.84865 5.0767C1.66699 5.43322 1.66699 5.89993 1.66699 6.83335Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillCc);
export default __webpack_public_path__ + "static/media/bill-cc.6e6057e08c8b2324704644659660640e.svg";
export { ForwardRef as ReactComponent };